import Pagination from './_pagination';

export default Pagination;
